"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostProductEdit = void 0;
const Base_1 = require("./Base");
exports.PostProductEdit = {
    url: Base_1.URL_BASE + "/ProductEdit",
    method: "POST",
    secure: true
};
//# sourceMappingURL=PostProductEdit.js.map